"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormActions = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FormActions = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 0.8rem;\n\n    a {\n        display: block;\n        margin-right: 0.8rem;\n        margin-bottom: 0.8rem;\n        font-weight: 400;\n        cursor: pointer;\n\n        ", ";\n\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            display: inline-flex;\n            align-items: center;\n            margin-bottom: 0;\n        "]))));

exports.FormActions = FormActions;